export const PRICING_MODAL_PRESETS = {
    minHeight: '500px',
    maxHeight: '80%',
    width: '90%',
    maxWidth: '1300px',
    bottom: '0',
    transform: 'translateX(-50%)',
    position: 'absolute',
    left: '50%',
};
//# sourceMappingURL=Modal.presets.js.map